export enum SocialProgramSubscriptionType {
    Subscription = "Subscription",
    NonSubscription = "Non-subscription"
}
